/* ==========================================================================
   MYGANG / Perfection Media — Add-to-cart complementary upsell popup
   --------------------------------------------------------------------------
   Strādā GAN cart "drawer", GAN cart "page" režīmā:
   - DRAWER: noklausās theme:product:add, aiztur drawer auto-atvēršanu,
     atver popup.
   - PAGE: pārtver produkta formas submit capture-fāzē PIRMS tēmas handlera,
     veic AJAX add pats, aptur tēmas pāradresāciju uz /cart un atver popup.
   - Ielādē complementary produktus (metafield -> kolekcijas fallback).
   - "Turpināt uz grozu" aizver popup un aizved uz grozu (drawer vai /cart).
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-mygang-upsell]';
  var OPEN_CLASS = 'is-open';
  var BODY_LOCK = 'mygang-upsell-lock';

  function moneyRoutes() {
    return (window.theme && window.theme.routes) || {};
  }

  // Formatē cenu (centi -> string), izmantojot tēmas formatētāju.
  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      var fmt = window.theme.moneyFormat || '${{amount}}';
      try { return window.theme.formatMoney(cents, fmt); } catch (e) {}
    }
    // Rezerves variants.
    return (cents / 100).toFixed(2);
  }

  function MygangUpsell(root) {
    this.root = root;
    this.dialog = root.querySelector('[data-mygang-upsell-dialog]');
    this.overlay = root.querySelector('[data-mygang-upsell-overlay]');
    this.productsWrap = root.querySelector('[data-mygang-upsell-products]');
    this.loading = root.querySelector('[data-mygang-upsell-loading]');
    this.empty = root.querySelector('[data-mygang-upsell-empty]');
    this.recUrl = root.getAttribute('data-rec-url');
    this.limit = parseInt(root.getAttribute('data-limit'), 10) || 3;
    this.addText = root.getAttribute('data-add-text') || 'Add';
    this.addedText = root.getAttribute('data-added-text') || 'Added';
    this.viewMoreText = root.getAttribute('data-view-more-text') || 'View product';

    this.loaded = false;
    this.hasProducts = false;
    this.isOpen = false;
    this.suppressDrawer = false;

    this.onKeydown = this.onKeydown.bind(this);
    this.close = this.close.bind(this);

    this.bind();
  }

  MygangUpsell.prototype.bind = function () {
    var self = this;

    if (this.overlay) this.overlay.addEventListener('click', this.close);

    this.root.querySelectorAll('[data-mygang-upsell-close]').forEach(function (btn) {
      btn.addEventListener('click', self.close);
    });

    var cont = this.root.querySelector('[data-mygang-upsell-continue]');
    if (cont) {
      cont.addEventListener('click', function (e) {
        // Drawer režīmā aizveram popup un atveram drawer (bez pārlādes).
        if (self.cartType() === 'drawer') {
          e.preventDefault();
          self.close();
          document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true }));
        }
        // Page režīmā ļaujam saitei aizvest uz /cart.
      });
    }
  };

  MygangUpsell.prototype.cartType = function () {
    return (window.theme && window.theme.settings && window.theme.settings.cartType) || '';
  };

  MygangUpsell.prototype.pageAdd = function (form, submitter) {
    var self = this;
    var routes = moneyRoutes();
    var addUrl = routes.cart_add_url || '/cart/add';
    if (!/\.js$/.test(addUrl)) addUrl += '.js';

    if (submitter) {
      submitter.classList.add('is-loading');
      submitter.setAttribute('disabled', 'disabled');
    }

    var formData = new FormData(form);

    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          // Kļūda (piem., nav noliktavā) — atlaižam tēmas kļūdas plūsmu.
          throw data;
        }
        self.resetButton(submitter);
        self.suppressDrawer = true;
        // Atjaunojam grozu skaitītāju / saturu fonā.
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

        // Atveram popup ja ir produkti; citādi ejam uz /cart kā parasti.
        self.loadRecommendations(function (hasProducts) {
          if (hasProducts) {
            self.open();
          } else {
            window.location = routes.cart_url || '/cart';
          }
        });
      })
      .catch(function (err) {
        self.resetButton(submitter);
        // Ja pievienošana neizdevās — kritiens atpakaļ uz normālu /cart.
        if (err && err.status) {
          window.location = routes.cart_url || '/cart';
        }
      });
  };

  MygangUpsell.prototype.resetButton = function (btn) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.removeAttribute('disabled');
  };

  MygangUpsell.prototype.open = function () {
    if (this.isOpen) return;
    this.isOpen = true;
    this.root.classList.add(OPEN_CLASS);
    this.root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(BODY_LOCK);
    document.addEventListener('keydown', this.onKeydown);
    var focusable = this.root.querySelector('[data-mygang-upsell-close]');
    if (focusable) focusable.focus();
    // Izceļam atlaides līmeni atbilstoši grozā esošo preču skaitam.
    this.updateTiers();
  };

  // Nolasa grozā esošo preču skaitu un izceļ AUGSTĀKO sasniegto atlaides līmeni.
  MygangUpsell.prototype.updateTiers = function () {
    var self = this;
    var tiersWrap = this.root.querySelector('[data-mygang-upsell-tiers]');
    if (!tiersWrap) return;
    var tiers = tiersWrap.querySelectorAll('.mygang-upsell__tier');
    if (!tiers.length) return;

    var routes = moneyRoutes();
    var cartUrl = (routes.cart_url || '/cart');
    var cartJsUrl = /\.js$/.test(cartUrl) ? cartUrl : cartUrl.split('?')[0] + '.js';

    fetch(cartJsUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        self.applyTierState(tiers, count);
      })
      .catch(function () {
        // Ja neizdodas nolasīt grozu — atstājam bez izcēluma.
      });
  };

  // Atzīmē sasniegtos līmeņus + izceļ augstāko sasniegto.
  MygangUpsell.prototype.applyTierState = function (tiers, count) {
    var reachedEl = null;
    var reachedMin = -1;

    tiers.forEach(function (t) {
      var min = parseInt(t.getAttribute('data-tier-min'), 10) || 0;
      t.classList.remove('is-active', 'is-reached');
      if (count >= min && min > 0) {
        t.classList.add('is-reached');
        if (min > reachedMin) { reachedMin = min; reachedEl = t; }
      }
    });

    if (reachedEl) reachedEl.classList.add('is-active');
  };

  MygangUpsell.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.suppressDrawer = false;
    this.root.classList.remove(OPEN_CLASS);
    this.root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(BODY_LOCK);
    document.removeEventListener('keydown', this.onKeydown);
  };

  MygangUpsell.prototype.onKeydown = function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) this.close();
  };

  // Ielādē rekomendācijas:
  //  1. Inline complementary metafield JSON (renderēts servera pusē).
  //  2. Ja tukšs -> fetch rec_url (related fallback).
  MygangUpsell.prototype.loadRecommendations = function (cb) {
    var self = this;
    cb = cb || function () {};

    if (this.loaded) {
      cb(this.hasProducts);
      return;
    }

    // 1. Inline complementary metafield.
    var inline = this.readInlineComplementary();
    if (inline.length > 0) {
      this.finishLoad(inline, cb);
      return;
    }

    // 2. Related fallback caur endpoint.
    if (!this.recUrl) {
      this.finishLoad([], cb);
      return;
    }
    this.fetchProducts(this.recUrl, function (products) {
      self.finishLoad(products, cb);
    });
  };

  MygangUpsell.prototype.readInlineComplementary = function () {
    var el = this.root.querySelector('[data-mygang-upsell-complementary]');
    if (!el) return [];
    try {
      var arr = JSON.parse(el.textContent.trim());
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  };

  MygangUpsell.prototype.fetchProducts = function (url, done) {
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('rec fetch failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var holder = doc.querySelector('[data-mygang-upsell-json]');
        var products = [];
        if (holder) {
          try { products = JSON.parse(holder.textContent.trim()); }
          catch (err) { products = []; }
        }
        done(products || []);
      })
      .catch(function () { done([]); });
  };

  MygangUpsell.prototype.finishLoad = function (products, cb) {
    var rendered = this.render(products);
    this.loaded = true;
    this.hasProducts = rendered > 0;
    cb(this.hasProducts);
  };

  MygangUpsell.prototype.showEmpty = function () {
    if (this.loading) this.loading.remove();
    if (this.empty) this.empty.hidden = false;
  };

  MygangUpsell.prototype.render = function (products) {
    if (this.loading) this.loading.remove();

    var usable = (products || []).filter(function (p) {
      return p && p.available;
    }).slice(0, this.limit);

    if (!usable.length) {
      this.showEmpty();
      return 0;
    }

    var self = this;
    usable.forEach(function (p) {
      var card = self.buildCard(p);
      if (card) self.productsWrap.appendChild(card);
    });
    return usable.length;
  };

  // Veido vienu produkta kartiņu ar variantu izvēli (ja vajag), cenu un
  // pārsvītrotu compare-at cenu. Pievienošana notiek popup iekšā.
  // Veido vienu produkta kartiņu: liela bilde -> nosaukums -> cena ->
  // poga "Apskatīt vairāk". BEZ variantu izvēles un BEZ pievienošanas grozā —
  // klients vēlas, lai cilvēks vispirms aiziet apskatīt produktu.
  MygangUpsell.prototype.buildCard = function (p) {
    var current = this.firstAvailableVariant(p);
    var href = p.url || '#';

    var card = document.createElement('div');
    card.className = 'mygang-upsell-card';

    // --- Image (liela, ~2x) ---
    var media = document.createElement('a');
    media.className = 'mygang-upsell-card__media';
    media.href = href;
    media.setAttribute('aria-label', p.title || '');
    var imgSrc = (current && current.image) || p.image;
    if (imgSrc) {
      var img = document.createElement('img');
      img.className = 'mygang-upsell-card__img';
      img.loading = 'lazy';
      img.alt = p.title || '';
      img.src = imgSrc;
      media.appendChild(img);
    }
    card.appendChild(media);

    // --- Info: nosaukums -> cena -> poga ---
    var info = document.createElement('div');
    info.className = 'mygang-upsell-card__info';

    var title = document.createElement('a');
    title.className = 'mygang-upsell-card__title';
    title.href = href;
    title.textContent = p.title || '';
    info.appendChild(title);

    var price = document.createElement('div');
    price.className = 'mygang-upsell-card__price';
    info.appendChild(price);
    card._price = price;

    card.appendChild(info);

    // "Apskatīt tuvāk" — saite uz produktu, kartiņas labajā malā.
    var viewBtn = document.createElement('a');
    viewBtn.className = 'mygang-upsell-card__view';
    viewBtn.href = href;
    viewBtn.textContent = this.viewMoreText;
    card.appendChild(viewBtn);

    this.renderPrice(card, current, p);
    return card;
  };

  // Atrod pirmo pieejamo variantu (cenai/bildei).
  MygangUpsell.prototype.firstAvailableVariant = function (p) {
    if (!p.variants || !p.variants.length) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) return p.variants[i];
    }
    return p.variants[0];
  };

  // Cena + pārsvītrota compare-at cena + ietaupījuma %.
  MygangUpsell.prototype.renderPrice = function (card, variant, p) {
    var el = card._price;
    if (!el) return;

    var price = variant ? variant.price : p.price_min;
    var compare = variant ? variant.compare_at_price : p.compare_at_price_max;
    var varies = (!variant || p.price_varies) && p.price_min !== p.price_max;

    var html = '';
    if (varies) {
      html += '<span class="mygang-upsell-card__price-new">' + formatMoney(p.price_min) + '+</span>';
    } else {
      html += '<span class="mygang-upsell-card__price-new">' + formatMoney(price) + '</span>';
      if (compare && compare > price) {
        html += '<span class="mygang-upsell-card__price-old">' + formatMoney(compare) + '</span>';
        var pct = Math.round((1 - price / compare) * 100);
        if (pct > 0) {
          html += '<span class="mygang-upsell-card__save">-' + pct + '%</span>';
        }
      }
    }
    el.innerHTML = html;
  };

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getController() {
    var el = document.querySelector(SELECTOR);
    if (!el) return null;
    if (!el.__mygangUpsell) el.__mygangUpsell = new MygangUpsell(el);
    return el.__mygangUpsell;
  }

  function cartTypeNow() {
    return (window.theme && window.theme.settings && window.theme.settings.cartType) || '';
  }

  // ============================================================
  // GLOBĀLAIS INTERCEPTORS — pievienots UZREIZ (pirms DOM ready),
  // lai garantēti būtu PIRMAIS theme:cart:add klausītājs.
  // ============================================================

  // ---- Kopīgā pievienošanas loģika ----
  function handleAdd(form, btn, stopEvent) {
    var ctrl = getController();
    if (!ctrl) return false; // nav popup uz šīs lapas

    // Neiejaucamies, ja pievienošana nāk no PAŠA popup kartiņas.
    if (btn && btn.closest && btn.closest(SELECTOR)) return false;
    if (!form) return false;

    // Validācija tāpat kā tēmā.
    if (form.checkValidity && !form.checkValidity()) {
      if (form.reportValidity) form.reportValidity();
      return false;
    }

    if (stopEvent) stopEvent();
    ctrl.pageAdd(form, btn);
    return true;
  }

  // PRIMĀRAIS trigeris: tiešs ATC pogas klikšķis (capture fāzē).
  // Šis NEPAĻAUJAS uz tēmas theme:cart:add notikumu — strādā arī tad,
  // ja <product-form> kāda iemesla dēļ to neizsauc (app-block setup u.c.).
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-add-to-cart]') : null;
    if (!btn) return;
    if (btn.closest(SELECTOR)) return; // popup iekšējā poga
    if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;

    var form = btn.closest('form');
    if (!form) return;

    // Tikai parastā ATC poga (ne dinamiskais checkout / "Pirkt tagad").
    if (btn.name === 'checkout' || /payment-button|shopify-payment-button|dynamic-checkout/.test(btn.className)) return;

    var handled = handleAdd(form, btn, function () {
      e.preventDefault();
      e.stopImmediatePropagation();
    });
    if (handled) return;
  }, true); // capture — pirms tēmas pašas klikšķa klausītāja

  // SEKUNDĀRAIS trigeris: ja tēma tomēr izsauc theme:cart:add.
  // (Atstājam drošībai; handleAdd neizpildīsies divreiz, jo pirmais klikšķis
  //  jau apturēja noklusējumu un atvēra popup.)
  document.addEventListener('theme:cart:add', function (e) {
    var btn = e.detail && e.detail.button;
    var form = btn && btn.closest ? btn.closest('form') : null;
    handleAdd(form, btn, function () {
      e.stopImmediatePropagation();
      e.preventDefault();
    });
  }, true); // capture — pirms tēmas bubble klausītāja

  // Papildu drošība: ja kaut kā theme:product:added tomēr izsaucas
  // (drawer auto-open trigeris), apturam to, kamēr mūsu popup ir atvērts.
  document.addEventListener('theme:product:added', function (e) {
    var el = document.querySelector(SELECTOR);
    var ctrl = el && el.__mygangUpsell;
    if (ctrl && (ctrl.isOpen || ctrl.suppressDrawer)) {
      e.stopImmediatePropagation();
      ctrl.suppressDrawer = false;
    }
  }, true);

  function init() {
    getController();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor — pārinicializē, ja sekciju pārzīmē.
  document.addEventListener('shopify:section:load', init);
})();
